/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    TemplateRecommendedReleasesReleases,
    TemplateRecommendedReleasesReleasesFromJSON,
    TemplateRecommendedReleasesReleasesFromJSONTyped,
    TemplateRecommendedReleasesReleasesToJSON,
} from './TemplateRecommendedReleasesReleases';

/**
 * 配信目的に紐づく推奨のプレスリリース
 * @export
 * @interface PurposeRecommendedReleases
 */
export interface PurposeRecommendedReleases {
    /**
     * 配信目的ID
     * @type {number}
     * @memberof PurposeRecommendedReleases
     */
    purposeId: number;
    /**
     * 
     * @type {number}
     * @memberof PurposeRecommendedReleases
     */
    templateId: number;
    /**
     * 配信目的カテゴリ名
     * @type {string}
     * @memberof PurposeRecommendedReleases
     */
    categoryName: string;
    /**
     * 配信目的名
     * @type {string}
     * @memberof PurposeRecommendedReleases
     */
    purposeName: string;
    /**
     * 
     * @type {Array<TemplateRecommendedReleasesReleases>}
     * @memberof PurposeRecommendedReleases
     */
    releases: Array<TemplateRecommendedReleasesReleases>;
}

export function PurposeRecommendedReleasesFromJSON(json: any): PurposeRecommendedReleases {
    return PurposeRecommendedReleasesFromJSONTyped(json, false);
}

export function PurposeRecommendedReleasesFromJSONTyped(json: any, ignoreDiscriminator: boolean): PurposeRecommendedReleases {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'purposeId': json['purpose_id'],
        'templateId': json['template_id'],
        'categoryName': json['category_name'],
        'purposeName': json['purpose_name'],
        'releases': ((json['releases'] as Array<any>).map(TemplateRecommendedReleasesReleasesFromJSON)),
    };
}

export function PurposeRecommendedReleasesToJSON(value?: PurposeRecommendedReleases | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'purpose_id': value.purposeId,
        'template_id': value.templateId,
        'category_name': value.categoryName,
        'purpose_name': value.purposeName,
        'releases': ((value.releases as Array<any>).map(TemplateRecommendedReleasesReleasesToJSON)),
    };
}

